import {
  GET_DESKTOP_ACTIVITY_REQUESTED,
  GET_DESKTOP_ACTIVITY_SUCCESS,
  GET_DESKTOP_ACTIVITY_FAILURE,
  GET_DESKTOP_EVENTS_REQUESTED,
  GET_DESKTOP_EVENTS_SUCCESS,
  GET_DESKTOP_EVENTS_FAILURE,
} from './desktop.constants'

import { GET_CONTACT_REQUESTED } from '../MediaPlayer/mediaPlayer.constants'

const initialState = {
  activity: {
    loading: true,
    error: false,
    data: null,
  },
  events: {
    loading: true,
    error: false,
    data: null,
  },
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CONTACT_REQUESTED:
      return { ...initialState }
    case GET_DESKTOP_ACTIVITY_REQUESTED:
      return {
        ...state,
        activity: {
          loading: true,
          error: false,
          data: null,
        },
      }
    case GET_DESKTOP_ACTIVITY_SUCCESS:
      return {
        ...state,
        activity: {
          loading: false,
          error: false,
          data: action.data,
        },
      }
    case GET_DESKTOP_ACTIVITY_FAILURE:
      return {
        ...state,
        activity: {
          loading: false,
          error: action.error,
          data: null,
        },
      }
    case GET_DESKTOP_EVENTS_REQUESTED:
      return {
        ...state,
        events: {
          loading: true,
          error: false,
          data: null,
        },
      }
    case GET_DESKTOP_EVENTS_SUCCESS:
      return {
        ...state,
        events: {
          loading: false,
          error: false,
          data: action.data,
        },
      }
    case GET_DESKTOP_EVENTS_FAILURE:
      return {
        ...state,
        events: {
          loading: false,
          error: action.error,
          data: null,
        },
      }
    default:
      return state
  }
}
